import React from "react";

const Approach = () => (
  <div className="bg-white text-black py-16 md:py-32">
    <div className="max-w-4xl px-5 mx-auto text-center">
      <h2 className="text-4xl lg:text-5xl font-extrabold my-5">We approach credit <span className="text-primary-txt">differently.</span></h2>
      <p className="text-lg lg:text-xl">The credit system today is outdated and broken, so we decided to take a whole new approach to credit and we want you to be a part of it.</p>
    </div>
  </div>
);

export default Approach;
